import { css } from 'styled-components';
import { rem } from 'polished';

const sizes = {
  lg: 1200,
  md: 992,
  sm: 768,
};

const font = {
  primary: '#333333',
  secondary: '#a9a9a9',
};

const base = '#eeeeee';

const table = {
  evenRowBg: base,
  oddRowBg: '#eaeaea',
};

const color = {
  separator: '#ddd',
  inactive: '#ddd',
  secondary: '#f8c730',
  warning: '#FF9800',
  success: '#57B752',
  danger: '#FE0E0E',
  deny: '#EE3939',
  base,
  white: '#fff',
  black: '#000',
  disable: '#777',
  primary: '#db173f',
  darkerPrimary: '#b90834',
  seatSelected: '#83001b',
  notFound: '#aaa',
  info: '#16367a',
  delimiter: '#efefef',
  font,
  table,
};

const media = {
  sm: (...args) => css`
    @media (min-width: ${sizes.sm}px) {
      ${css(...args)};
    }
  `,
  md: (...args) => css`
    @media (min-width: ${sizes.md}px) {
      ${css(...args)};
    }
  `,
  lg: (...args) => css`
    @media (min-width: ${sizes.lg}px) {
      ${css(...args)};
    }
  `,
};

export const theme = {
  borderRadius: `${rem(3)}`,
  shadow: `0 ${rem(2)} ${rem(12)} 0 rgba(0, 0, 0, 0.05)`,
  media,
  color,
};



// WEBPACK FOOTER //
// ./src/theme.js